// extracted by mini-css-extract-plugin
export default {"accordion":"RegisterAccordion_accordion--L0_","accordionBody":"RegisterAccordion_accordionBody--BDH"};